<template>
  <div>
    <PeriodicExamineModal ref="PeriodicExamineModal" v-on:callbackSuccess="getTableData(table.page)"></PeriodicExamineModal>
    <Card>
      <Row class="sm-pc-w100">
        <Col :md="22">
          <Form :model="searchForm" ref="searchForm" inline :label-width="60">
            <FormItem label="策略名称">
              <Input v-model="searchForm.name" style="min-width: 200px" />
            </FormItem>
            <FormItem label="配置项">
              <Input v-model="searchForm.option" style="min-width: 200px" />
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getTableData()">搜索</Button>
              <Button style="margin-left: 8px" @click="searchReset">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :md="2" class="align-right">
          <Button
            style="float: right;"
            @click="editStrategy(0)"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">添加策略</Button>
        </Col>
      </Row>
      <Table
        border
        :loading="TableLoading"
        :data="table.data"
        :columns="table.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getConfigStrategyList, deleteConfigStrategy } from '@/api/network'
import PeriodicExamineModal from '../components/periodic-examine'

export default {
  name: 'list',
  components: {
    PeriodicExamineModal
  },
  data () {
    return {
      TableLoading: false,
      table: {
        data: [],
        columns: [
          {
            title: '策略名',
            key: 'name',
            tooltip: true,
            align: 'center',
            minWidth: 100
          },
          {
            title: '配置项',
            key: 'option',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '命令',
            key: 'cmd',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '匹配规则数目',
            key: 'rule',
            align: 'center',
            tooltip: true,
            minWidth: 110,
            render: (h, params) => {
              return h('span', params.row.rule.length)
            }
          },
          {
            title: '创建用户',
            tooltip: true,
            align: 'center',
            key: 'create_user_full_name',
            minWidth: 90
          },
          {
            title: '创建时间',
            tooltip: true,
            align: 'center',
            key: 'created_format',
            minWidth: 150
          },
          {
            title: '最后修改用户',
            tooltip: true,
            align: 'center',
            key: 'change_user_full_name',
            minWidth: 120
          },
          {
            title: '最后修改时间',
            tooltip: true,
            align: 'center',
            key: 'changed_format',
            minWidth: 150
          },
          {
            title: '定时校验',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              let periodicExamineBtnType = 'default'
              let periodicExamineBtnIcon = 'md-close'
              if (params.row.periodic_task) {
                if (params.row.periodic_task.enabled === true) {
                  periodicExamineBtnType = 'success'
                  periodicExamineBtnIcon = 'md-checkmark'
                }
              }
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: periodicExamineBtnType,
                    size: 'small',
                    icon: periodicExamineBtnIcon
                  },
                  on: {
                    click: () => {
                      this.$refs.PeriodicExamineModal.openModal(params.row.id)
                    }
                  }
                }, '定时校验')
              ])
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 180,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'network_strategy_detail',
                        params: { 'id': params.row.id }
                      })
                    }
                  }
                }, '详情'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editStrategy(params.row.id)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.Delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 1,
        page: 1,
        size: 10
      },
      searchForm: {
        name: '',
        option: ''
      }
    }
  },
  mounted: function () {
    this.getTableData()
  },
  methods: {
    // 获取表格数据
    getTableData (value = 1) {
      this.table.page = value
      let params = {
        size: this.table.size,
        page: this.table.page,
        name: this.searchForm.name,
        option: this.searchForm.option
      }
      this.TableLoading = true
      getConfigStrategyList(params).then(res => {
        this.TableLoading = false
        this.table.data = res.data.results
        this.table.count = res.data.count
      }).catch(res => {
        this.TableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取策略列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取策略列表失败！服务器无响应'
          })
        }
      })
    },
    // 搜索重置
    searchReset () {
      this.searchForm = {
        name: '',
        option: ''
      }
    },
    // 打开编辑策略
    editStrategy (id) {
      if (id) {
        this.$router.push({
          name: 'network_strategy_edit',
          params: { id: id }
        })
      } else {
        this.$router.push({
          name: 'network_strategy_add'
        })
      }
    },
    Delete (strategy) {
      deleteConfigStrategy(strategy.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
